export const isAdminUser = (): boolean => {
  try {
    const rawUser = localStorage.getItem("user");
    if (!rawUser) return false;

    const user = JSON.parse(rawUser);
    const userType = String(user?.userType || "").toUpperCase();
    if (userType === "ADMIN" || userType === "ADMINISTRATOR") return true;

    // Some backends may provide roles/authorities as an array or string.
    const roles =
      user?.roles || user?.role || user?.authorities || user?.permissions;

    const roleMatchesAdmin = (role: unknown) => {
      const r = String(role ?? "").toUpperCase();
      if (!r) return false;
      return r === "ADMIN" || r === "ROLE_ADMIN" || r.includes("ADMIN");
    };

    if (Array.isArray(roles)) {
      return roles.some(roleMatchesAdmin);
    }

    if (typeof roles === "string") {
      return roleMatchesAdmin(roles);
    }

    return false;
  } catch {
    return false;
  }
};

